import { Track } from 'livekit-client'

import {
  CameraDisabledIcon,
  CameraIcon,
  MicDisabledIcon,
  MicIcon,
  ScreenShareIcon,
  ScreenShareStopIcon,
} from '@/src/assets/icons'

import { IBranding } from '@/src/types/meetData.type'

import { getSessionStorageItem } from '@/src/helpers/storage'

/**
 * @internal
 */
export function useGetSourceIcon(source: Track.Source, enabled: boolean) {
  const color = getSessionStorageItem<IBranding>('brandingData')?.text_primary_color

  switch (source) {
    case Track.Source.Microphone:
      return enabled ? (
        <MicIcon fill={color ?? '#fff'} />
      ) : (
        <MicDisabledIcon fill={color ?? '#fff'} />
      )
    case Track.Source.Camera:
      return enabled ? (
        <CameraIcon fill={color ?? '#fff'} />
      ) : (
        <CameraDisabledIcon fill={color ?? '#fff'} />
      )
    case Track.Source.ScreenShare:
      return enabled ? (
        <ScreenShareStopIcon fill={color ?? '#fff'} />
      ) : (
        <ScreenShareIcon fill={color ?? '#fff'} />
      )
    default:
      return undefined
  }
}
